import { makeStyles, theme } from '@focaldata/cin-ui-components'

const useStyles = makeStyles()({
  title: {
    paddingRight: theme.spacing(4)
  }
})

export default useStyles
